/* eslint-disable import/no-unresolved */
import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { swalMessages } from '@auteco/constants'
import { FaTag } from 'react-icons/fa'
import { ScreenLoading2 } from '../../components/sharedComponents/ScreenLoading/index'
import TerritoriosPage from '../../pages/PolygonsPage/TerritoriesPage/TerritoriesPage'
import filterArray from '../../utils/filterArray'
import { Context } from '../../context/Contex'
import polygonsService from '../../services/polygonsService'

const TerritoriesContainer = () => {
  const [zona, setZona] = useState('')
  const [select, setSelect] = useState('')
  const [search, setSearch] = useState('')
  const [territorios, setTerritorios] = useState('')
  const [searchTerritory, setSearchTerritory] = useState('')
  const [territorioszonas, SetTerritorioszonas] = useState([])

  const { unidad, permisos } = useContext(Context)
  const history = useHistory()
  const dataTable = []

  /*= =======================================================================
  Get Territorios
======================================================================== */
  const getTerritories = async () => {
    const response = await polygonsService.getTerritorios(unidad)
    setTerritorios(response)
  }

  /*= =======================================================================
  Get Territorio y Zonas
======================================================================== */
  const getTerritoriesZones = () => {
    polygonsService
      .getTerritorioyZona(unidad)
      .then(response => {
        SetTerritorioszonas(response.data.data)
      })
      .catch(error => {
        console.log(error)
        history.push('/login')
      })
  }

  /*= =======================================================================
  Get Zonas
======================================================================== */
  const getZones = () => {
    polygonsService
      .getZonas(unidad)
      .then(response => {
        setZona(response.data.data)
      })
      .catch(error => {
        console.log(error)
        history.push('/login')
      })
  }

  useEffect(() => {
    getTerritories()
    getTerritoriesZones()
    getZones()
  }, [unidad])

  /*= =======================================================================
 Post Territorios
======================================================================== */
  const handleCreateTerritory = ({ value }) => {
    const body = { territorio: value, unidad_negocio_id: unidad }
    polygonsService
      .postTerritorios(body)
      .then(response => {
        if (response.data.id === 0) {
          swal(swalMessages.REPEAT_MESSAGE_ERROR)
        } else {
          getTerritories()
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  /*= =======================================================================
  Editar Territorios
======================================================================== */
  const handleUpdate = params => {
    polygonsService
      .putTerritorios(params)
      .then(response => {
        if (response.data.id === 0) {
          swal(swalMessages.ASSIGNMENT_ESTABLICHED)
        } else {
          setSelect(params)
          getTerritories()
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  /*= =======================================================================
  Eliminar Territorios
======================================================================== */
  const handleDelete = params => () => {
    swal(swalMessages.DELETE_CONFIRM).then(willDelete => {
      if (willDelete) {
        polygonsService
          .deleteTerritorio(params)
          .then(response => {
            if (response.data.id === 0) {
              swal(swalMessages.DELETE_ERROR)
            } else {
              getTerritories()
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    })
  }

  /*= =======================================================================
Asignar Zonas a Territorios
======================================================================== */
  const handleCreate = params => () => {
    polygonsService
      .postTerritoriosZonas(params)
      .then(response => {
        if (response.data.id === 0) {
          swal(swalMessages.ASSIGNMENT_ESTABLICHED)
        } else {
          getTerritoriesZones()
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  /*= =======================================================================
  Eliminar Zonas y territirios
======================================================================== */
  const handleDeleteZyT = ({ rowData }) => {
    swal(swalMessages.DELETE_CONFIRM).then(willDelete => {
      if (willDelete) {
        polygonsService
          .deleteTerritorioZona(rowData)
          .then(() => {
            getTerritoriesZones()
          })
          .catch(error => {
            console.log(error)
          })
      }
    })
  }
  const handleSelect = item => () => {
    setSelect(item)
  }

  const handleSearch = event => {
    setSearch(event.target.value)
  }
  const handleSearchTerritory = event => {
    setSearchTerritory(event.target.value)
  }

  if (territorioszonas) {
    try {
      territorioszonas.forEach(datos => {
        dataTable.push({
          color:
            typeof datos === 'object' ? (
              <FaTag alt="nophoto" style={{ fontSize: 20, color: `${datos.color}` }} />
            ) : (
              datos.color
            ),
          territorio: datos.territorio,
          territorio_id: datos.territorio_id,
          zona: datos.zona,
          zona_id: datos.zona_id,
          unidad_negocio_id: datos.unidad_negocio_id,
        })
      })
    } catch (err) {
      console.log(err, 'tabla territorios')
    }
  }

  const filtered = filterArray(zona, 'zona', search)
  const filteredTerritory = filterArray(territorios, 'territorio', searchTerritory)

  if (!territorioszonas || !zona || !territorios) {
    return <ScreenLoading2 />
  }

  return (
    <>
      <TerritoriosPage
        territorios={filteredTerritory}
        territorioszonas={dataTable}
        permisos={permisos}
        zona={filtered}
        select={select}
        handleSearchTerritory={handleSearchTerritory}
        onCreateTerritory={handleCreateTerritory}
        handleDeleteZyT={handleDeleteZyT}
        handleDelete={handleDelete}
        handleUpdate={handleUpdate}
        handleCreate={handleCreate}
        handleSearch={handleSearch}
        handleSelect={handleSelect}
      />
    </>
  )
}

export default TerritoriesContainer
